import { render, staticRenderFns } from "./Custom_Forms.vue?vue&type=template&id=57331c10"
import script from "./Custom_Forms.vue?vue&type=script&lang=js"
export * from "./Custom_Forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports